/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
// import queryString from "query-string"
import { faChevronDown, faChevronUp, faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Ajv from "ajv"
import ajvErrors from "ajv-errors"
import dayjs from "dayjs"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Collapse, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useLocation, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T営業所マスタ } from "../../../components/ComboBox/EigyosyoComboBox"
import { T銀行口座マスタ } from "../../../components/ComboBox/GinkoKozaComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { T社員マスタ } from "../../../components/ComboBox/SyainComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import RequiredMark from "../../../components/RequiredMark"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import SyainSearchModal from "../../../components/SearchModal/SyainSearchModal"
import SyaryoSearchModal from "../../../components/SearchModal/SyaryoSearchModal"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import CONSTANT from "../../../constant"
import { 区分分類コード } from "../../../constant/enum/codes"
import { e請求書作成区分, T請求書作成区分 } from "../../../constant/enum/master"
import { メニューコード } from "../../../constant/menuCode"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { setAlerts } from "../../../globalStore/alertStore"
import { 画面ロック解除, 画面ロック開始 } from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import BusyoService from "../../../service/master/busyo/busyoService"
import EigyosyoService from "../../../service/master/eigyosyo/eigyosyoService"
import GinkoKozaService from "../../../service/master/ginkoKoza/ginkoKozaService"
import KubunService from "../../../service/master/kubun/kubunService"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import { ninusiSeikyuUtiwakePutReqSchema } from "../../../service/master/ninusiseikyu/NinusiSeikyuSchema"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import {
  TNinusiSeikyuInfoGetRes,
  TNinusiSeikyuRegisterPostReq,
  TNinusiSeikyuRegisterPostRes,
  TNinusiSeikyuUpdatePutReq,
  TNinusiSeikyuUpdatePutRes,
  TNinusiSeikyuUtiwakePutReq,
  TSeikyuUtiwakeListInfo,
} from "../../../service/master/ninusiseikyu/TNinusiSeikyu"
import SyainService from "../../../service/master/syain/syainService"
import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import commonUtil from "../../../ts/util/commonUtil"
import { TWijmoCellTemplateContext, TWijmoComboBox } from "../../../type/wijmoComponents"

const MasterNinusiSeikyuRegister = () => {
  const history = useHistory()
  const location = useLocation()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const disPatch: AppDispatch = useDispatch()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find((m) => m.メニューコード === メニューコード.マスタ管理.荷主請求マスタ登録)
        ?.読み取り専用フラグ
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region[types]
  type T請求内訳 = TSeikyuUtiwakeListInfo & {
    行ID: symbol
  }
  //#endregion

  //#region [state]

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  // 表示項目のstate
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()
  const [表紙分割コード, set表紙分割コード] = useState<string>()
  const [表紙名, set表紙名] = useState<string>()
  const [請求先名, set請求先名] = useState<string>()
  const [郵便番号, set郵便番号] = useState<string>()
  const [住所１, set住所１] = useState<string>()
  const [住所２, set住所２] = useState<string>()
  const [住所３, set住所３] = useState<string>()
  const [請求先担当者, set請求先担当者] = useState<string>()
  const [電話番号, set電話番号] = useState<string>()
  const [FAX番号, setFAX番号] = useState<string>()
  const [メールアドレス, setメールアドレス] = useState<string>()
  const [請求担当社員コード, set請求担当] = useState<T社員マスタ["社員コード"] | null>(null)
  const [請求担当ItemSource, set請求担当ItemSource] = useState<T社員マスタ[]>()
  const [締日区分コード, set締日区分コード] = useState<string | null>()
  const [請求書作成区分コード, set請求書作成区分コード] = useState<string | null>()
  const [請求書印刷区分コード, set請求書印刷区分コード] = useState<string | null>()
  const [明細小計表示区分コード, set明細小計表示区分コード] = useState<string | null>()
  const [品代端数計算区分コード, set品代端数計算区分コード] = useState<string | null>()
  //const [消費税表示区分コード, set消費税表示区分コード] = useState<
  //  string | null
  //>()
  const [消費税計算区分コード, set消費税計算区分コード] = useState<string | null>()
  const [明細ソート区分コード, set明細ソート区分コード] = useState<string | null>()
  // const [高速料税込区分コード, set高速料税込区分コード] = useState<
  //   string | null
  // >()
  const [コース編集区分コード, setコース編集区分コード] = useState<string | null>()
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [請求営業所コード, set請求営業所コード] = useState<T営業所マスタ["営業所コード"] | null>(null)
  const [営業所ItemSource, set営業所ItemSource] = useState<T営業所マスタ[]>()
  const [銀行口座ID, set銀行口座] = useState<T銀行口座マスタ["銀行口座ID"] | null>(null)
  const [銀行口座ItemSource, set銀行口座ItemSource] = useState<T銀行口座マスタ[]>()
  const [備考, set備考] = useState<string>("")
  const [荷主請求更新日時, set荷主請求更新日時] = useState<string>()
  const [荷主請求更新ユーザID, set荷主請求更新ユーザID] = useState<string>()
  const [廃止日時, set廃止日時] = useState<string>()
  const [請求内訳更新日時, set請求内訳更新日時] = useState<string>()
  const [請求内訳更新ユーザID, set請求内訳更新ユーザID] = useState<string>()

  //#region [comboboxState]
  // 営業所（請求書発行元）
  const [営業所ComboBox, set営業所ComboBox] = useState<TWijmoComboBox<string, T営業所マスタ> | null>(null)
  const [営業所IsLoadEnded, set営業所IsLoadEnded] = useState<boolean>(false)
  // 請求担当
  const [請求担当ComboBox, set請求担当ComboBox] = useState<TWijmoComboBox<string, T社員マスタ> | null>(null)
  const [請求担当IsLoadEnded, set請求担当IsLoadEnded] = useState<boolean>(false)
  // 銀行口座
  const [銀行口座ComboBox, set銀行口座ComboBox] = useState<TWijmoComboBox<
    T銀行口座マスタ["銀行口座ID"],
    T銀行口座マスタ
  > | null>(null)
  const [銀行口座IsLoadEnded, set銀行口座IsLoadEnded] = useState<boolean>(false)
  // 締日区分
  const [締日区分ComboBox, set締日区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [締日区分IsLoadEnded, set締日区分IsLoadEnded] = useState<boolean>(false)
  // 請求書作成区分
  const [請求書作成区分ComboBox, set請求書作成区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [請求書作成区分IsLoadEnded, set請求書作成区分IsLoadEnded] = useState<boolean>(false)
  // 請求書印刷区分
  const [請求書印刷区分ComboBox, set請求書印刷区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [請求書印刷区分IsLoadEnded, set請求書印刷区分IsLoadEnded] = useState<boolean>(false)
  // 明細小計表示区分
  const [明細小計表示区分ComboBox, set明細小計表示区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [明細小計表示区分IsLoadEnded, set明細小計表示区分IsLoadEnded] = useState<boolean>(false)
  // 品代端数計算区分（区分値は消費税計算区分と同じ）
  const [品代端数計算区分IsLoadEnded, set品代端数計算区分IsLoadEnded] = useState<boolean>(false)

  //インボイス対応により削除
  // 消費税表示区分
  // const [消費税表示区分ComboBox, set消費税表示区分ComboBox] =
  //   useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
  //     null
  //   )
  //const [消費税表示区分IsLoadEnded, set消費税表示区分IsLoadEnded] =
  useState<boolean>(false)
  // 消費税計算区分
  const [消費税計算区分ComboBox, set消費税計算区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [消費税計算区分IsLoadEnded, set消費税計算区分IsLoadEnded] = useState<boolean>(false)
  // 明細ソート区分
  const [明細ソート区分ComboBox, set明細ソート区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [明細ソート区分IsLoadEnded, set明細ソート区分IsLoadEnded] = useState<boolean>(false)

  //インボイス対応により削除
  // 高速料税込区分
  // const [高速料税込区分ComboBox, set高速料税込区分ComboBox] =
  //   useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
  //     null
  //   )
  // const [高速料税込区分IsLoadEnded, set高速料税込区分IsLoadEnded] =
  //   useState<boolean>(false)
  // コース編集区分
  const [コース編集区分ComboBox, setコース編集区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [コース編集区分IsLoadEnded, setコース編集区分IsLoadEnded] = useState<boolean>(false)

  // 項目制御
  const [請求書印刷区分IsDisabled, set請求書印刷区分IsDisabled] = useState<boolean>(false)
  const [明細小計表示区分IsDisabled, set明細小計表示区分IsDisabled] = useState<boolean>(false)
  const [品代端数計算区分IsDisabled, set品代端数計算区分IsDisabled] = useState<boolean>(false)
  // const [消費税表示区分IsDisabled, set消費税表示区分IsDisabled] =
  //   useState<boolean>(false)
  const [消費税計算区分IsDisabled, set消費税計算区分IsDisabled] = useState<boolean>(false)
  const [明細ソート区分IsDisabled, set明細ソート区分IsDisabled] = useState<boolean>(false)

  //インボイス対応により削除
  //const [高速料税込区分IsDisabled, set高速料税込区分IsDisabled] =
  //  useState<boolean>(false)
  const [コース編集区分IsDisabled, setコース編集区分IsDisabled] = useState<boolean>(false)

  // ***** 請求内訳グリッド
  const [detailDataGrid, setDetailDataGrid] = useState<wjGrid.FlexGrid>()
  const [itemsSource, setItemSource] = useState<wjcCore.CollectionView>()

  // 計上基準日区分
  const [計上基準日区分DataMap, set計上基準日区分DataMap] = useState<wjGrid.DataMap<T区分マスタ>>()
  // 請求車輌区分
  const [請求車輌区分DataMap, set請求車輌区分DataMap] = useState<wjGrid.DataMap<T区分マスタ>>()
  // 課税区分
  const [課税区分DataMap, set課税区分DataMap] = useState<wjGrid.DataMap<T区分マスタ>>()
  // 請求担当
  const [請求担当DataMap, set請求担当DataMap] = useState<wjGrid.DataMap<T社員マスタ>>()
  // 計上部所
  const [計上部所DataMap, set計上部所DataMap] = useState<wjGrid.DataMap<T部所マスタ>>()

  // 請求内訳グリッドの初期化時フラグ
  const [isInitGrid, setIsInitGrid] = useState(false)

  //grid内エラー項目格納Array
  const [errorCellPositionList] = useState<Array<{ 行ID: symbol; colBinding: string }>>([])

  // アラート用State
  const [内訳AlertSource, set内訳AlertSource] = useState<any>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isHaisiConfirmModalShow, setIsHaisiConfirmModalShow] = useState(false)
  const [isHaisiKaizyoConfirmModalShow, setIsHaisiKaizyoConfirmModalShow] = useState(false)
  const [isUtiwakeConfirmModalShow, setIsUtiwakeConfirmModalShow] = useState(false)
  const [is荷主検索ModalShow, setIs荷主検索ModalShow] = useState(false)
  const [is車輌検索Modal, setIs車輌検索Modal] = useState(false)
  const [is社員検索Modal, setIs社員検索Modal] = useState(false)
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)
  const [選択行, set選択行] = useState<wjGrid.Row>()
  //#endregion

  //#region [method]

  /**
   * 荷主請求データ取得
   */
  const getData = async (id: number, signal: AbortSignal) => {
    const service = new NinusiSeikyuService()

    try {
      const res = await service.get(id)
      if (res.data) {
        // データを画面に貼り付け
        await set荷主請求Data(res)

        //請求内訳データ
        const utiwakeListRes = await new NinusiSeikyuService().getListUchiwake(
          {
            荷主請求Id: res.data.荷主請求ID,
          },
          signal
        )
        if (detailDataGrid !== undefined) {
          // 荷主請求内訳の中で最も最新のレコードの最新更新日時名などを表示する
          if (utiwakeListRes.data.length > 0) {
            const 最新内訳 = utiwakeListRes.data.reduce((max, item) => {
              if (!item.更新日時) return max
              if (!max) return item
              return dayjs(item.更新日時).isAfter(dayjs(max.更新日時)) ? item : max
            }, null as TSeikyuUtiwakeListInfo | null)
            if (最新内訳 != null) {
              set請求内訳更新日時(最新内訳.更新日時)
              set請求内訳更新ユーザID(最新内訳.更新ユーザID ? 最新内訳.更新ユーザID.toString() : "")
            }
          }

          detailDataGrid.itemsSource.sourceCollection = [
            ...utiwakeListRes.data.map((d) => ({ ...d, 行ID: Symbol() })),
          ] as T請求内訳[]
          setItemSource(detailDataGrid.itemsSource)
        }
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  const set荷主請求Data = async (res: TApiResponse<TNinusiSeikyuInfoGetRes>) => {
    //荷主請求データ
    set荷主コード(res.data.荷主コード)
    set荷主名(res.data.荷主名)
    set表紙分割コード(res.data.表紙分割コード)
    set表紙名(res.data.表紙名)
    set請求担当(res.data.請求担当社員コード)
    set締日区分コード(res.data.締日区分コード)
    set請求書作成区分コード(res.data.請求書作成区分コード)
    set請求書印刷区分コード(res.data.請求書印刷区分コード)
    set明細小計表示区分コード(res.data.明細小計表示区分コード)
    set品代端数計算区分コード(res.data.品代端数計算区分コード)
    //set消費税表示区分コード(res.data.消費税表示区分コード)
    set消費税計算区分コード(res.data.消費税計算区分コード)
    set明細ソート区分コード(res.data.明細ソート区分コード)
    // set高速料税込区分コード(res.data.高速料税込区分コード)
    setコース編集区分コード(res.data.コース編集区分コード)
    set郵便番号(res.data.郵便番号)
    set住所１(res.data.住所１)
    set住所２(res.data.住所２)
    set住所３(res.data.住所３)
    set請求先名(res.data.請求先名)
    set請求先担当者(res.data.請求先担当者)
    set電話番号(res.data.電話番号)
    setFAX番号(res.data.FAX番号)
    setメールアドレス(res.data.メールアドレス)
    set請求営業所コード(res.data.請求営業所コード)
    set銀行口座(res.data.銀行口座ID)
    set備考(res.data.備考)
    set荷主請求更新日時(res.data.更新日時)
    set荷主請求更新ユーザID(res.data.更新ユーザID ? res.data.更新ユーザID.toString() : "")
    set廃止日時(res.data.廃止日)
  }

  // 請求内訳グリッドの初期化
  const initGrid = (grid: wjGrid.FlexGrid) => {
    // 請求内訳GridのCollectionView
    grid.itemsSource = new wjcCore.CollectionView<Partial<T請求内訳>>([], {
      calculatedFields: {
        sort_請求内訳コード: (i: T請求内訳) =>
          commonUtil.createSortString(i.請求内訳コード, VALIDATE_CONSTANT.LENGTH.請求内訳コード),
      },

      sortDescriptions: [new wjcCore.SortDescription("sort_請求内訳コード", true)],

      newItemCreator(): Partial<T請求内訳> {
        return {
          行ID: Symbol(),
          請求内訳コード: "",
          請求内訳名: "",
          内訳担当社員コード: "",
          内訳担当社員氏名: "",
          月固定フラグ: 0,
          計上基準日区分コード: "",
          請求車輌区分コード: "",
          運賃タリフフラグ: 0,
          トン数補償フラグ: 0,
          乗務員売上フラグ: 0,
          高速料請求フラグ: 0,
          運行売上外フラグ: 0,
          定額車番: "",
          固定請求課税区分コード: "",
          固定請求額: undefined,
          備考: "",
          計上部所コード: "",
          計上乗務員社員コード: "",
        }
      },
    })

    setItemSource(grid.itemsSource)
    setDetailDataGrid(grid)

    // 初回遷移時はフラグをOnにする
    if (isInitGrid === false) setIsInitGrid(true)
  }

  //TODO:色変えイベント
  // gridの必須チェックおよび検索イベント
  const formatItemHandler = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        let isErrorCell = false
        const rowData: T請求内訳 = e.getRow().dataItem
        const cellBinding = e.getColumn().binding

        // 削除フラグ
        const row = e.getRow()
        row.isReadOnly = rowData.削除フラグ === 1
        wjcCore.toggleClass(e.cell, "read-only-cell", rowData.削除フラグ === 1)

        // エラーセルの色変え
        if (errorCellPositionList.find((e) => e.colBinding === cellBinding && e.行ID === rowData.行ID)) {
          isErrorCell = true
        }
        wjcCore.toggleClass(e.cell, "data-warning", isErrorCell)
      }
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = (s: wjGrid.FlexGrid, e: wjGrid.CellEditEndingEventArgs) => {
    let col = s.columns[e.col]
    if (e.cancel === true) {
      return
    }
    let dataItem: T請求内訳 = e.getRow().dataItem

    // Grid上のテキストクリア時にIDをクリアする
    switch (col.binding as keyof T請求内訳) {
      case "定額車番":
        if (dataItem.定額車番 === "") {
          dataItem.定額車輌ID = undefined
        }
        s.refresh()
        break
      case "計上乗務員社員名":
        if (dataItem.計上乗務員社員名 === "") {
          dataItem.計上乗務員ID = undefined
        }
        s.refresh()
        break
      default:
        break
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    setIsConfirmModalShow(true)
  }

  /**
   * 送信前バリデーションチェック（内訳）
   */
  const beforeUtiwakeSubmit = () => {
    set内訳AlertSource(undefined)

    // TODO: バリデーションチェック
    errorCellPositionList.splice(0, errorCellPositionList.length)

    let schema = ninusiSeikyuUtiwakePutReqSchema
    let [行IDList, dataList] = createUtiwakePutReq()
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    // 一行ごとにチェック
    dataList.forEach((data, i) => {
      // 削除行はチェックしない
      if (data.削除フラグ === 1) return
      const validate = ajv.compile(schema)
      const validateResult = validate(data)

      if (!validateResult) {
        console.log(validate.errors)
        validate.errors?.forEach((error) => {
          // TODO:エラーデータをわかるように加工
          const colBinding = error.instancePath.slice(1)
          if (!errorCellPositionList.find((e) => e.行ID === 行IDList[i] && e.colBinding === colBinding)) {
            errorCellPositionList.push({ 行ID: 行IDList[i], colBinding })
          }
        })
      }
    })

    if (errorCellPositionList.length <= 0) {
      setIsUtiwakeConfirmModalShow(true)
    } else {
      console.log(errorCellPositionList)
      set内訳AlertSource({
        warns: ["請求内訳の入力に不備があります。"],
      })
      detailDataGrid?.refresh()
    }
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      let data: TNinusiSeikyuRegisterPostReq
      const set請求書作成区分コード = 請求書作成区分コード as T請求書作成区分

      switch (set請求書作成区分コード) {
        case e請求書作成区分.受注配車:
          data = {
            荷主コード: 荷主コード!,
            表紙分割コード: 表紙分割コード!,
            表紙名: 表紙名!,
            請求先名: 請求先名!,
            郵便番号: 郵便番号!,
            住所１: 住所１!,
            住所２: 住所２!,
            住所３: 住所３!,
            電話番号,
            FAX番号,
            メールアドレス,
            請求先担当者,
            請求担当社員コード: 請求担当社員コード!,
            請求書作成区分コード: set請求書作成区分コード,
            締日区分コード: 締日区分コード!,
            請求書印刷区分コード: 請求書印刷区分コード!,
            明細小計表示区分コード: 明細小計表示区分コード!,
            品代端数計算区分コード: 品代端数計算区分コード!,
            //消費税表示区分コード: 消費税表示区分コード!,
            消費税計算区分コード: 消費税計算区分コード!,
            明細ソート区分コード: 明細ソート区分コード!,
            //高速料税込区分コード: 高速料税込区分コード!,
            コース編集区分コード: コース編集区分コード!,
            請求営業所コード: 請求営業所コード!,
            銀行口座ID: 銀行口座ID!,
            備考,
          }
          break
        case e請求書作成区分.月固定:
          data = {
            荷主コード: 荷主コード!,
            表紙分割コード: 表紙分割コード!,
            表紙名: 表紙名!,
            請求先名: 請求先名!,
            郵便番号: 郵便番号!,
            住所１: 住所１!,
            住所２: 住所２!,
            住所３: 住所３!,
            電話番号,
            FAX番号,
            メールアドレス,
            請求先担当者,
            請求担当社員コード: 請求担当社員コード!,
            請求書作成区分コード: set請求書作成区分コード,
            締日区分コード: 締日区分コード!,
            請求書印刷区分コード: 請求書印刷区分コード!,
            明細小計表示区分コード: 明細小計表示区分コード!,
            //消費税表示区分コード: 消費税表示区分コード!,
            消費税計算区分コード: 消費税計算区分コード!,
            明細ソート区分コード: 明細ソート区分コード!,
            //高速料税込区分コード: 高速料税込区分コード!,
            請求営業所コード: 請求営業所コード!,
            銀行口座ID: 銀行口座ID!,
            備考,
          }
          break
        default:
          const new請求書作成区分コード = set請求書作成区分コード as typeof e請求書作成区分.手作成
          data = {
            荷主コード: 荷主コード!,
            表紙分割コード: 表紙分割コード!,
            表紙名: 表紙名!,
            請求先名: 請求先名!,
            郵便番号: 郵便番号!,
            住所１: 住所１!,
            住所２: 住所２!,
            住所３: 住所３!,
            電話番号,
            FAX番号,
            メールアドレス,
            請求先担当者,
            請求担当社員コード: 請求担当社員コード!,
            請求書作成区分コード: new請求書作成区分コード,
            締日区分コード: 締日区分コード!,
            請求営業所コード: 請求営業所コード!,
            銀行口座ID: 銀行口座ID!,
            備考,
          }
          break
      }

      const service = new NinusiSeikyuService()

      let res: TApiResponse<TNinusiSeikyuRegisterPostRes | TNinusiSeikyuUpdatePutRes>
      if (id) {
        const putData: TNinusiSeikyuUpdatePutReq = {
          ...data,
          更新日時: 荷主請求更新日時 ? 荷主請求更新日時.toString() : "",
        }
        res = await service.put(id, putData)
      } else {
        res = await service.post(data)
      }
      disPatch(setAlerts(res))
      if (res) {
        //請求内訳の入力を連続して行う可能性あるため遷移しない
        if (!id) {
          isPrompt.current = false
          set荷主請求Data(res)

          // 新規登録の際は URLを変更
          history.replace(`${location.pathname}/${res.data.荷主請求ID}`)
        } else {
          isPrompt.current = true
          set荷主請求Data(res)
        }

        showInfoToast(`荷主請求マスタの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   *
   * 削除前バリデーションチェックなど
   */
  const beforeHaisiSubmit = () => {
    setIsHaisiConfirmModalShow(true)
  }

  /**
   * 廃止
   */
  const doHaisi = async () => {
    try {
      const service = new NinusiSeikyuService()
      const res: TApiResponse<boolean> = await service.haisi(id!, {
        更新日時: 荷主請求更新日時!,
      })
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`荷主請求マスタを廃止しました`)
      }
    } catch (error) {
      const errorResponse = error as TApiResponse<any>
      if (errorResponse.warns != null) {
        const 受注配車存在エラー = errorResponse.warns.find((w) => w.code === "W2401")
        if (受注配車存在エラー != null) {
          errorResponse.warns.push({
            code: "",
            message: `　対象受注配車`,
            messageWithCode: `　対象受注配車`,
            target: "",
            values: [],
          })
          let message = ""
          受注配車存在エラー.values.forEach((受注配車No: string) => {
            message += `${受注配車No} `
          })
          errorResponse.warns.push({
            code: "",
            message: message,
            messageWithCode: message,
            target: "",
            values: [],
          })
        }
      }
      disPatch(setAlerts(error))
    } finally {
      setIsHaisiConfirmModalShow(false)
    }
  }

  /**
   *
   * 廃止解除前バリデーションチェックなど
   */
  const beforeHaisiKaizyoSubmit = () => {
    setIsHaisiKaizyoConfirmModalShow(true)
  }

  /**
   * 廃止解除
   */
  const doHaisiKaizyo = async () => {
    try {
      const service = new NinusiSeikyuService()
      const res: TApiResponse<boolean> = await service.haisiKaizyo(id!, {
        更新日時: 荷主請求更新日時!,
      })
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`荷主請求マスタを復帰しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsHaisiKaizyoConfirmModalShow(false)
    }
  }

  /**
   * 請求内訳　更新アイテム生成
   * @returns
   */
  const createUtiwakePutReq = (): [symbol[], TNinusiSeikyuUtiwakePutReq[]] => {
    const 行IDList: symbol[] = []
    const 請求内訳明細: Array<TNinusiSeikyuUtiwakePutReq> = []
    const arrayDataList = itemsSource?.items as unknown as T請求内訳[]

    for (const arrayData of arrayDataList) {
      // エラー発生時の行番号特定のために行IDを同一indexで保存していく
      行IDList.push(arrayData.行ID)
      請求内訳明細.push({
        荷主請求内訳ID: arrayData.荷主請求内訳ID ? arrayData.荷主請求内訳ID : undefined,
        荷主請求ID: arrayData.荷主請求ID ? arrayData.荷主請求ID : id!, // IDが存在する場合のみ処理呼び出すのでIDは必須扱い
        請求内訳コード: arrayData.請求内訳コード,
        請求内訳名: arrayData.請求内訳名,
        請求内訳担当社員コード: arrayData.内訳担当社員コード,
        月固定フラグ: arrayData.月固定フラグ ? 1 : 0,
        乗務員売上フラグ: arrayData.乗務員売上フラグ ? 1 : 0,
        計上基準日区分コード: arrayData.計上基準日区分コード ?? "",
        請求車輌区分コード: arrayData.請求車輌区分コード ?? "",
        運賃タリフフラグ: arrayData.運賃タリフフラグ ? 1 : 0,
        トン数補償フラグ: arrayData.トン数補償フラグ ? 1 : 0,
        乗務員手当フラグ: arrayData.乗務員手当フラグ ? 1 : 0,
        高速料請求フラグ: arrayData.高速料請求フラグ ? 1 : 0,
        運行売上外フラグ: arrayData.運行売上外フラグ ? 1 : 0,
        定額車輌ID: arrayData.定額車輌ID ? arrayData.定額車輌ID : undefined,
        固定請求課税区分コード: arrayData.固定請求課税区分コード,
        固定請求額: arrayData.固定請求額 ?? undefined,
        備考: arrayData.備考,
        計上部所コード: arrayData.計上部所コード ?? "",
        // 計上部所ID: arrayData.計上部所ID ? arrayData.計上部所ID : undefined,
        計上乗務員ID: arrayData.計上乗務員ID ? arrayData.計上乗務員ID : undefined,
        更新日時: arrayData.更新日時,
        削除フラグ: arrayData.削除フラグ ? 1 : 0,
      })
    }
    return [行IDList, 請求内訳明細]
  }

  /**
   * 送信（内訳）
   */
  const utiwakeSubmit = async () => {
    console.log("submit")

    if (!id) return setIsConfirmModalShow(false)
    try {
      const service = new NinusiSeikyuService()

      let res: TApiResponse<TSeikyuUtiwakeListInfo[]> = await service.putUtiwake(createUtiwakePutReq()[1])

      disPatch(setAlerts(res))
      if (res) {
        if (detailDataGrid !== undefined) {
          detailDataGrid.itemsSource.sourceCollection = [
            ...res.data.map((d) => ({ ...d, 行ID: Symbol() })),
          ] as T請求内訳[]
          setItemSource(detailDataGrid.itemsSource)
          detailDataGrid.refresh()
        }
        showInfoToast(`荷主請求マスタ（請求内訳）の${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsUtiwakeConfirmModalShow(false)
    }
  }

  const update荷主 = async (荷主コード: string) => {
    set荷主名("")

    if (荷主コード == null || wjcCore.isNullOrWhiteSpace(荷主コード)) return

    try {
      const res = await new NinusiService().getList({
        荷主コード: 荷主コード,
        完全一致フラグ: true,
      })

      if (res.data.length === 1) {
        set荷主名(res.data[0].荷主名)
        set郵便番号(res.data[0].郵便番号)
        set住所１(res.data[0].住所１)
        set住所２(res.data[0].住所２)
        set住所３(res.data[0].住所３)
        set電話番号(res.data[0].電話番号)
        setFAX番号(res.data[0].FAX番号)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }
  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    const abortController = new AbortController()
    Promise.all([
      new KubunService().getList(),
      new SyainService().getList({}),
      new BusyoService().getList({}),
      new EigyosyoService().getList(),
      new GinkoKozaService().getList(),
    ]).then(([区分マスタRes, 請求担当Res, 部所Res, 営業所Res, 銀行口座Res]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)

      set区分ItemSource(区分マスタRes.data)
      請求担当Res &&
        set請求担当ItemSource(
          請求担当Res.data.filter((i: T社員マスタ) => {
            return i.請求担当フラグ === 1
          })
        )
      営業所Res &&
        set営業所ItemSource(
          営業所Res.data.filter((j: T営業所マスタ) => {
            return j.請求書発行元フラグ === 1
          })
        )
      銀行口座Res && set銀行口座ItemSource(銀行口座Res.data)

      const 計上基準日区分List = 区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.マスタ.計上基準日区分)

      const 請求車輌区分List = 区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.マスタ.請求車輌区分)

      const empty区分 = {
        区分コード: "",
        名称1: "",
      }

      //必須ではないため空白を追加
      set計上基準日区分DataMap(
        new wjGrid.DataMap<T区分マスタ>([empty区分, ...計上基準日区分List], "区分コード", "名称1")
      )

      //必須ではないため空白を追加
      set請求車輌区分DataMap(new wjGrid.DataMap<T区分マスタ>([empty区分, ...請求車輌区分List], "区分コード", "名称1"))

      const new請求担当DataMap = new wjGrid.DataMap<T社員マスタ>(請求担当Res.data, "社員コード", "社員氏名")
      // 既に転属した社員などがgridで表示されるときに社員コードのみ表示されてしまうため、全件取得したのちにフィルターをかける
      new請求担当DataMap.collectionView.filter = (i: T社員マスタ) => {
        return i.請求担当フラグ === 1
      }
      set請求担当DataMap(new請求担当DataMap)
      set課税区分DataMap(
        new wjGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分),
          "区分コード",
          "名称1"
        )
      )

      //必須ではないため空白を追加
      const empty部所 = {
        部所コード: "",
        部所略称: "",
      }
      set計上部所DataMap(new wjGrid.DataMap<T部所マスタ>([empty部所, ...部所Res.data], "部所コード", "部所略称"))

      // id存在時はデータを取得し更新
      if (id) {
        getData(id, abortController.signal).finally(() => {
          disPatch(画面ロック解除())
        })
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      } else {
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      }
    })

    return () => {
      abortController.abort()
    }
  }, [isInitGrid])

  //請求書作成区分による利用可否制御
  useEffect(() => {
    switch (請求書作成区分コード) {
      case e請求書作成区分.受注配車:
        set請求書印刷区分IsDisabled(false)
        set明細小計表示区分IsDisabled(false)
        set品代端数計算区分IsDisabled(false)
        //set消費税表示区分IsDisabled(false)
        set消費税計算区分IsDisabled(false)
        set明細ソート区分IsDisabled(false)
        //set高速料税込区分IsDisabled(false)
        setコース編集区分IsDisabled(false)
        break
      case e請求書作成区分.月固定:
        set請求書印刷区分IsDisabled(false)
        set明細小計表示区分IsDisabled(false)
        set品代端数計算区分IsDisabled(true) //利用不可
        //set消費税表示区分IsDisabled(false)
        set消費税計算区分IsDisabled(false)
        set明細ソート区分IsDisabled(false)
        //set高速料税込区分IsDisabled(false)
        setコース編集区分IsDisabled(true) //利用不可
        break
      case e請求書作成区分.手作成:
        set請求書印刷区分IsDisabled(true)
        set明細小計表示区分IsDisabled(true)
        set品代端数計算区分IsDisabled(true)
        //set消費税表示区分IsDisabled(true)
        set消費税計算区分IsDisabled(true)
        set明細ソート区分IsDisabled(true)
        //set高速料税込区分IsDisabled(true)
        setコース編集区分IsDisabled(true)
        break
      default:
        break
    }
  }, [請求書作成区分コード])

  //#endregion

  return (
    <>
      <Prompt when={isPrompt.current} message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>

      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">荷主請求マスタ{id ? `更新` : `登録`}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 荷主請求登録カード */}
            <Card>
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon icon={accordionController ? faChevronDown : faChevronUp} size={"1x"} />
                請求書設定
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Container fluid className="register-form">
                    <div className="register-form-row">
                      {/* 荷主 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="荷主">
                            荷主
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            autoFocus={id == null}
                            style={{ width: "6rem" }}
                            id="荷主コード"
                            name="荷主コード"
                            isReadOnly={id ? true : false}
                            value={荷主コード}
                            setValue={(v) => {
                              set荷主コード(v)
                            }}
                            maxLength={VALIDATE_CONSTANT.LENGTH.荷主コード}
                            placeholder="荷主CD"
                            tabIndex={1001}
                            onBlur={(e) => {
                              // 新規登録時のみ
                              if (id != null) return
                              update荷主(荷主コード ?? "")
                            }}
                          />
                          {/* 荷主検索モーダル */}
                          {id == null && (
                            <button
                              type="button"
                              disabled={id ? true : false}
                              onClick={() => {
                                setIs荷主検索ModalShow(true)
                              }}
                              className="icon-button"
                              tabIndex={1002}>
                              <FontAwesomeIcon className="icon-button-inner" icon={faSearch}></FontAwesomeIcon>
                            </button>
                          )}
                          <NinusiSearchModal
                            isShow={is荷主検索ModalShow}
                            setIsShow={setIs荷主検索ModalShow}
                            setNinusi={(荷主) => {
                              // 新規登録時のみ
                              if (id != null) return
                              set荷主コード(荷主.荷主コード)
                              set荷主名(荷主.荷主名)
                              set郵便番号(荷主.郵便番号)
                              set住所１(荷主.住所１)
                              set住所２(荷主.住所２)
                              set住所３(荷主.住所３)
                              set電話番号(荷主.電話番号)
                              setFAX番号(荷主.FAX番号)
                            }}></NinusiSearchModal>
                          <TextInput
                            style={{ width: "30rem" }}
                            id="荷主名"
                            name="荷主名"
                            isReadOnly={true}
                            value={荷主名}
                            setValue={set荷主名}
                            maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                            placeholder="荷主名"
                            tabIndex={1003}
                          />
                        </div>
                      </div>
                      {/* 請求担当 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="請求担当">
                            請求担当
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Syain
                            isLoadEnded={請求担当IsLoadEnded}
                            setIsLoadEnded={set請求担当IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            itemsSource={請求担当ItemSource}
                            selectedValue={請求担当社員コード}
                            setSelectedValue={(v) => {
                              set請求担当(v)
                            }}
                            ComboBox={請求担当ComboBox}
                            setComboBox={set請求担当ComboBox}
                            tabIndex={2001}></ComboBox.Syain>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* 表紙名 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="表紙名">
                            表紙名
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            autoFocus={id != null}
                            style={{ width: "6rem" }}
                            id="表紙分割コード"
                            name="表紙分割コード"
                            value={表紙分割コード}
                            setValue={set表紙分割コード}
                            maxLength={VALIDATE_CONSTANT.LENGTH.表紙分割コード}
                            placeholder="表紙CD"
                            isRequired={true}
                            tabIndex={1011}
                          />
                          <TextInput
                            style={{ width: "25rem" }}
                            id="表紙名"
                            name="表紙名"
                            value={表紙名}
                            setValue={set表紙名}
                            maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                            placeholder="表紙名"
                            isRequired={true}
                            tabIndex={1012}
                          />
                        </div>
                      </div>
                      {/* 締日区分 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="締日区分">
                            締日区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={区分分類コード.マスタ.締日区分}
                            isLoadEnded={締日区分IsLoadEnded}
                            setIsLoadEnded={set締日区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            itemsSource={区分ItemSource}
                            selectedValue={締日区分コード}
                            setSelectedValue={set締日区分コード}
                            ComboBox={締日区分ComboBox}
                            setComboBox={set締日区分ComboBox}
                            tabIndex={2011}></ComboBox.Kubun>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* 郵便番号 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="郵便番号">
                            郵便番号
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            id="郵便番号"
                            name="郵便番号"
                            value={郵便番号}
                            setValue={set郵便番号}
                            maxLength={VALIDATE_CONSTANT.LENGTH.郵便番号}
                            placeholder="郵便番号"
                            isRequired={true}
                            tabIndex={1031}
                          />
                        </div>
                      </div>
                      {/* 請求書作成区分 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="請求書作成区分">
                            請求書作成区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={区分分類コード.マスタ.請求書作成区分}
                            isLoadEnded={請求書作成区分IsLoadEnded}
                            setIsLoadEnded={set請求書作成区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            itemsSource={区分ItemSource}
                            selectedValue={請求書作成区分コード}
                            setSelectedValue={set請求書作成区分コード}
                            ComboBox={請求書作成区分ComboBox}
                            setComboBox={set請求書作成区分ComboBox}
                            tabIndex={2031}></ComboBox.Kubun>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* 住所１ */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="住所１">
                            住所１
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            id="住所１"
                            name="住所１"
                            value={住所１}
                            setValue={set住所１}
                            maxLength={VALIDATE_CONSTANT.LENGTH.住所１}
                            placeholder="都道府県"
                            isRequired={true}
                            tabIndex={1041}
                          />
                        </div>
                      </div>
                      {/* 請求書印刷区分 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="請求書印刷区分">
                            請求書印刷区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={区分分類コード.マスタ.請求書印刷区分}
                            isLoadEnded={請求書印刷区分IsLoadEnded}
                            setIsLoadEnded={set請求書印刷区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            isDisabled={請求書印刷区分IsDisabled}
                            itemsSource={区分ItemSource}
                            selectedValue={請求書印刷区分コード}
                            setSelectedValue={set請求書印刷区分コード}
                            ComboBox={請求書印刷区分ComboBox}
                            setComboBox={set請求書印刷区分ComboBox}
                            tabIndex={2041}></ComboBox.Kubun>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* 住所２ */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="住所２">
                            住所２
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            id="住所２"
                            name="住所２"
                            value={住所２}
                            setValue={set住所２}
                            maxLength={VALIDATE_CONSTANT.LENGTH.住所２}
                            placeholder="市区町村"
                            isRequired={true}
                            tabIndex={1051}
                          />
                        </div>
                      </div>
                      {/* 明細小計表示区分 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="明細小計表示区分">
                            明細小計表示区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={区分分類コード.マスタ.明細小計表示区分}
                            isLoadEnded={明細小計表示区分IsLoadEnded}
                            setIsLoadEnded={set明細小計表示区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            isDisabled={明細小計表示区分IsDisabled}
                            itemsSource={区分ItemSource}
                            selectedValue={明細小計表示区分コード}
                            setSelectedValue={set明細小計表示区分コード}
                            ComboBox={明細小計表示区分ComboBox}
                            setComboBox={set明細小計表示区分ComboBox}
                            tabIndex={2051}></ComboBox.Kubun>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* 住所３ */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="住所３">
                            住所３
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            style={{ width: "30rem" }}
                            id="住所３"
                            name="住所３"
                            value={住所３}
                            setValue={set住所３}
                            maxLength={VALIDATE_CONSTANT.LENGTH.住所３}
                            placeholder="町名番地"
                            isRequired={true}
                            tabIndex={1061}
                          />
                        </div>
                      </div>
                      {/* 品代端数計算区分 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="品代端数計算区分">
                            品代端数計算区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={区分分類コード.マスタ.消費税計算区分}
                            isLoadEnded={品代端数計算区分IsLoadEnded}
                            setIsLoadEnded={set品代端数計算区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            isDisabled={品代端数計算区分IsDisabled}
                            itemsSource={区分ItemSource}
                            selectedValue={品代端数計算区分コード}
                            setSelectedValue={set品代端数計算区分コード}
                            ComboBox={消費税計算区分ComboBox}
                            setComboBox={set消費税計算区分ComboBox}
                            tabIndex={2061}></ComboBox.Kubun>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* 請求先名 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="請求先名">請求先部署</label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            style={{ width: "30rem" }}
                            id="請求先名"
                            name="請求先名"
                            value={請求先名}
                            setValue={set請求先名}
                            maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                            tabIndex={1071}
                          />
                        </div>
                      </div>
                      {/* 消費税表示区分
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="消費税表示区分">
                            消費税表示区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={区分分類コード.マスタ.消費税表示区分}
                            isLoadEnded={消費税表示区分IsLoadEnded}
                            setIsLoadEnded={set消費税表示区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            isDisabled={消費税表示区分IsDisabled}
                            itemsSource={区分ItemSource}
                            selectedValue={消費税表示区分コード}
                            setSelectedValue={set消費税表示区分コード}
                            ComboBox={消費税表示区分ComboBox}
                            setComboBox={set消費税表示区分ComboBox}
                            tabIndex={2061}></ComboBox.Kubun>
                        </div>
                      </div> */}
                      {/* 消費税計算区分 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="消費税計算区分">
                            消費税計算区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={区分分類コード.マスタ.消費税計算区分}
                            isLoadEnded={消費税計算区分IsLoadEnded}
                            setIsLoadEnded={set消費税計算区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            isDisabled={消費税計算区分IsDisabled}
                            itemsSource={区分ItemSource}
                            selectedValue={消費税計算区分コード}
                            setSelectedValue={set消費税計算区分コード}
                            ComboBox={消費税計算区分ComboBox}
                            setComboBox={set消費税計算区分ComboBox}
                            tabIndex={2071}></ComboBox.Kubun>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* 請求先担当者 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="請求先担当者">請求先担当</label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            id="請求先担当者"
                            name="請求先担当者"
                            value={請求先担当者}
                            setValue={set請求先担当者}
                            maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                            tabIndex={1081}
                          />
                        </div>
                      </div>
                      {/* 明細ソート区分 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="明細ソート区分">
                            明細ソート区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={区分分類コード.マスタ.明細ソート区分} //
                            isLoadEnded={明細ソート区分IsLoadEnded}
                            setIsLoadEnded={set明細ソート区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            isDisabled={明細ソート区分IsDisabled}
                            itemsSource={区分ItemSource}
                            selectedValue={明細ソート区分コード}
                            setSelectedValue={set明細ソート区分コード}
                            ComboBox={明細ソート区分ComboBox}
                            setComboBox={set明細ソート区分ComboBox}
                            tabIndex={2081}></ComboBox.Kubun>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* 電話番号 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="電話番号">電話番号</label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            id="電話番号"
                            name="電話番号"
                            value={電話番号}
                            setValue={set電話番号}
                            maxLength={VALIDATE_CONSTANT.LENGTH.電話番号}
                            tabIndex={1091}
                          />
                        </div>
                      </div>
                      {/* 高速料税込区分 */}
                      {/* <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="高速料税込区分">
                            高速料税込区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={
                              区分分類コード.受注配車_請求支払.税込区分
                            }
                            isLoadEnded={高速料税込区分IsLoadEnded}
                            setIsLoadEnded={set高速料税込区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            isDisabled={高速料税込区分IsDisabled}
                            itemsSource={区分ItemSource}
                            selectedValue={高速料税込区分コード}
                            setSelectedValue={set高速料税込区分コード}
                            ComboBox={高速料税込区分ComboBox}
                            setComboBox={set高速料税込区分ComboBox}
                            tabIndex={2091}></ComboBox.Kubun>
                        </div>
                      </div> */}
                      {/* コース編集区分 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="コース編集区分">
                            コース編集区分
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <ComboBox.Kubun
                            分類コード={区分分類コード.マスタ.コース編集区分}
                            isLoadEnded={コース編集区分IsLoadEnded}
                            setIsLoadEnded={setコース編集区分IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            isDisabled={コース編集区分IsDisabled}
                            itemsSource={区分ItemSource}
                            selectedValue={コース編集区分コード}
                            setSelectedValue={setコース編集区分コード}
                            ComboBox={コース編集区分ComboBox}
                            setComboBox={setコース編集区分ComboBox}
                            tabIndex={2101}></ComboBox.Kubun>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* FAX番号 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="FAX番号">FAX番号</label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            id="FAX番号"
                            name="FAX番号"
                            value={FAX番号}
                            setValue={setFAX番号}
                            maxLength={VALIDATE_CONSTANT.LENGTH.電話番号}
                            tabIndex={1101}
                          />
                        </div>
                      </div>
                      {/* 請求書発行元営業所 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="請求書発行元">
                            請求書発行元
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          {" "}
                          <ComboBox.Eigyosyo
                            isLoadEnded={営業所IsLoadEnded}
                            setIsLoadEnded={set営業所IsLoadEnded}
                            isEmpty={true}
                            isRequired={true}
                            itemsSource={営業所ItemSource}
                            selectedValue={請求営業所コード}
                            setSelectedValue={(v) => {
                              set請求営業所コード(v)
                            }}
                            ComboBox={営業所ComboBox}
                            setComboBox={set営業所ComboBox}
                            tabIndex={2111}></ComboBox.Eigyosyo>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* メールアドレス */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="メールアドレス">メールアドレス</label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextInput
                            style={{ width: "30rem" }}
                            id="メールアドレス"
                            name="メールアドレス"
                            value={メールアドレス}
                            type="email"
                            setValue={setメールアドレス}
                            maxLength={VALIDATE_CONSTANT.LENGTH.メールアドレス}
                            tabIndex={1111}
                          />
                        </div>
                      </div>
                      {/* 銀行口座 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="銀行口座">
                            銀行口座
                            <RequiredMark />
                          </label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <div className="w-30rem">
                            <ComboBox.GinkoKoza
                              isLoadEnded={銀行口座IsLoadEnded}
                              setIsLoadEnded={set銀行口座IsLoadEnded}
                              isEmpty={true}
                              isRequired={true}
                              itemsSource={銀行口座ItemSource}
                              selectedValue={銀行口座ID}
                              setSelectedValue={(v) => {
                                set銀行口座(v)
                              }}
                              ComboBox={銀行口座ComboBox}
                              setComboBox={set銀行口座ComboBox}
                              tabIndex={2121}></ComboBox.GinkoKoza>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="register-form-row">
                      {/* 備考 */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="備考">備考</label>
                        </div>
                        <div className="register-form-value w-40rem">
                          <TextAreaInput
                            className="w-100"
                            value={備考}
                            setValue={set備考}
                            tabIndex={1121}></TextAreaInput>
                        </div>
                      </div>
                    </div>
                  </Container>
                  {id && (
                    <>
                      <Row>
                        <Col>更新日時: {util.date.format(荷主請求更新日時, "YYYY/MM/DD HH:mm:ss")}</Col>
                      </Row>
                      <Row>
                        <Col>更新ユーザID : {荷主請求更新ユーザID}</Col>
                      </Row>
                      {!wjcCore.isNullOrWhiteSpace(廃止日時 ?? "") && (
                        <Row>
                          <Col>廃止日時 : {util.date.format(廃止日時, "YYYY/MM/DD HH:mm:ss")}</Col>
                        </Row>
                      )}
                    </>
                  )}
                  <Row className="search-button">
                    {!読取専用フラグ && (
                      <>
                        <Col xl={{ span: "auto", offset: 0 }}>
                          <Button
                            type="submit"
                            variant="waiting"
                            tabIndex={3001}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              beforeSubmit()
                            }}>
                            {id ? `更新` : `登録`}
                          </Button>
                        </Col>
                        {id && (
                          <Col xl={{ span: "auto", offset: 0 }}>
                            {wjcCore.isNullOrWhiteSpace(廃止日時 ?? "") ? (
                              <Button
                                type="submit"
                                variant="caution"
                                tabIndex={3001}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  e.preventDefault()
                                  beforeHaisiSubmit()
                                }}>
                                廃止
                              </Button>
                            ) : (
                              <Button
                                type="submit"
                                variant="caution"
                                tabIndex={3001}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  e.preventDefault()
                                  beforeHaisiKaizyoSubmit()
                                }}>
                                廃止解除
                              </Button>
                            )}
                          </Col>
                        )}
                      </>
                    )}
                    <Col>
                      <Button type="button" variant="secondary" tabIndex={3002} onClick={() => history.goBack()}>
                        一覧に戻る
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* <Col xs={6}> */}
            <Card>
              <Card.Header>請求内訳</Card.Header>
              <Card.Body>
                <Row>
                  <Col>
                    <LocalAlertComponent alertSource={内訳AlertSource} />
                  </Col>
                </Row>
                {/* グリッド START */}
                <wjrGrid.FlexGrid
                  {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                  tabOrder={4001}
                  initialized={initGrid}
                  // allowAddNew={id != null}
                  cellEditEnded={(s: wjGrid.FlexGrid, e: wjGrid.CellEditEndingEventArgs) => {
                    cellEditEnded(s, e)
                  }}
                  frozenColumns={2}
                  allowSorting={false}
                  formatItem={formatItemHandler}>
                  <wjrGrid.FlexGridColumn
                    binding="請求内訳コード"
                    header="CD"
                    sortMemberPath="sort_請求内訳コード"
                    maxLength={VALIDATE_CONSTANT.LENGTH.請求内訳コード}
                    width={50}>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="ColumnHeader"
                      template={() => {
                        return (
                          <>
                            <span>CD</span>
                            <RequiredMark />
                          </>
                        )
                      }}></wjrGrid.FlexGridCellTemplate>
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求内訳名"
                    header="請求内訳名"
                    maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                    width={180}>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="ColumnHeader"
                      template={() => {
                        return (
                          <>
                            <span>請求内訳名</span>
                            <RequiredMark />
                          </>
                        )
                      }}></wjrGrid.FlexGridCellTemplate>
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="内訳担当社員コード"
                    header="請求内訳担当"
                    maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                    dataMap={請求担当DataMap}
                    width={130}></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="月固定フラグ"
                    width={80}
                    dataType={wjcCore.DataType.Boolean}
                    header="月固定"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員売上フラグ"
                    width={80}
                    dataType={wjcCore.DataType.Boolean}
                    header="乗務員売上"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="計上基準日区分コード"
                    width={100}
                    dataMap={計上基準日区分DataMap}
                    header="計上基準日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="ColumnHeader"
                      template={() => {
                        return (
                          <>
                            <span>計上基準日</span>
                          </>
                        )
                      }}></wjrGrid.FlexGridCellTemplate>
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求車輌区分コード"
                    width={100}
                    dataMap={請求車輌区分DataMap}
                    header="請求車輌">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="ColumnHeader"
                      template={() => {
                        return (
                          <>
                            <span>請求車輌</span>
                          </>
                        )
                      }}></wjrGrid.FlexGridCellTemplate>
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="運賃タリフフラグ"
                    width={80}
                    dataType={wjcCore.DataType.Boolean}
                    header="運賃タリフ"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="トン数補償フラグ"
                    width={80}
                    dataType={wjcCore.DataType.Boolean}
                    header="トン数補償"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="乗務員手当フラグ"
                    width={80}
                    dataType={wjcCore.DataType.Boolean}
                    header="乗務員手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="高速料請求フラグ"
                    width={80}
                    dataType={wjcCore.DataType.Boolean}
                    header="高速料請求"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="運行売上外フラグ"
                    width={80}
                    dataType={wjcCore.DataType.Boolean}
                    header="運行売上外"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="定額車番"
                    header="定額車番"
                    maxLength={VALIDATE_CONSTANT.LENGTH.車番}
                    width={80}>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(context: TWijmoCellTemplateContext<T請求内訳>) => {
                        return (
                          <div className="d-flex justify-content-between">
                            <div className="text-start">{context.item.定額車番}</div>
                            <div className="text-end">
                              <a
                                href="*"
                                onClick={(e) => {
                                  e.preventDefault()
                                  set選択行(context.row)
                                  setIs車輌検索Modal(true)
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                              </a>
                            </div>
                          </div>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="固定請求課税区分コード"
                    width={80}
                    dataMap={課税区分DataMap}
                    header="課税区分"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="固定請求額"
                    header="固定請求額"
                    dataType={wjcCore.DataType.Number}
                    align="right"
                    width={100}></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="計上部所コード"
                    header="月固定計上部所"
                    isRequired={false}
                    dataMap={計上部所DataMap}
                    width={130}></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="計上乗務員社員名"
                    header="月固定計上乗務員"
                    isRequired={false}
                    width={130}>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(context: TWijmoCellTemplateContext<T請求内訳>) => {
                        return (
                          <div className="d-flex justify-content-between">
                            <div className="text-start">{context.item.計上乗務員社員名}</div>
                            <div className="text-end">
                              <a
                                href="*"
                                onClick={(e) => {
                                  e.preventDefault()
                                  set選択行(context.row)
                                  setIs乗務員検索Modal(true)
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                              </a>
                            </div>
                          </div>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn binding="備考" header="備考" width={250}></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn header="行削除" align="center" width={60} isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(context: TWijmoCellTemplateContext<T請求内訳>) => {
                        return context.item.削除フラグ !== 1 ? (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            variant={"caution"}
                            onClick={(e) => {
                              e.preventDefault()
                              if (context.item.荷主請求内訳ID != null) {
                                //TODO: DB登録済の行は削除フラグをONにする
                                context.item.削除フラグ = 1
                              } else {
                                if (itemsSource === undefined) return
                                itemsSource.removeAt(context.row.index)
                                //エラーリストより削除
                                const filtered = errorCellPositionList.filter(
                                  (d) => d.行ID !== context.row.dataItem.行ID
                                )
                                const length = errorCellPositionList.length
                                for (let i = 0; i < length; i++) {
                                  errorCellPositionList.shift()
                                }
                                errorCellPositionList.push(...filtered)

                                setItemSource(itemsSource)
                              }
                              detailDataGrid?.refresh()
                            }}>
                            削除
                          </Button>
                        ) : (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            variant={"pending"}
                            onClick={(e) => {
                              e.preventDefault()
                              context.item.削除フラグ = 0
                              detailDataGrid?.refresh()
                            }}>
                            解除
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                </wjrGrid.FlexGrid>
                {/* グリッド END */}
                {id && (
                  <>
                    <Row>
                      <Col>更新日時: {util.date.format(請求内訳更新日時, "YYYY/MM/DD HH:mm:ss")}</Col>
                    </Row>
                    <Row>
                      <Col>更新ユーザID : {請求内訳更新ユーザID}</Col>
                    </Row>
                  </>
                )}
                <Row className="search-button">
                  {!読取専用フラグ && (
                    <Col xl={{ span: "auto", offset: 0 }}>
                      <Button
                        type="submit"
                        variant="waiting"
                        disabled={id == null}
                        tabIndex={5001}
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          beforeUtiwakeSubmit()
                        }}>
                        {id ? `更新` : `登録`}
                      </Button>
                    </Col>
                  )}
                  <Col>
                    <Button type="button" variant="secondary" tabIndex={5002} onClick={() => history.goBack()}>
                      一覧に戻る
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <br />
      {/* 請求 */}
      <ConfirmModal isShow={isConfirmModalShow} hideHandler={setIsConfirmModalShow} submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal isShow={isHaisiConfirmModalShow} hideHandler={setIsHaisiConfirmModalShow} submitHandler={doHaisi}>
        荷主請求を本日付けで廃止しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isHaisiKaizyoConfirmModalShow}
        hideHandler={setIsHaisiKaizyoConfirmModalShow}
        submitHandler={doHaisiKaizyo}>
        荷主請求の廃止を解除しますか？
      </ConfirmModal>
      {/* 内訳 */}
      <ConfirmModal
        isShow={isUtiwakeConfirmModalShow}
        hideHandler={setIsUtiwakeConfirmModalShow}
        submitHandler={utiwakeSubmit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      {/* 車輌検索 */}
      <SyaryoSearchModal
        setIsShow={(v) => {
          setIs車輌検索Modal(v)
        }}
        isShow={is車輌検索Modal}
        setSyaryo={(車輌) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T請求内訳 = 選択行.dataItem
            casted.定額車輌ID = 車輌.車輌ID!
            casted.定額車番 = 車輌.車番!
            detailDataGrid?.refresh()
          }
        }}></SyaryoSearchModal>
      {/* 社員検索 */}
      <SyainSearchModal
        setIsShow={(v) => {
          setIs社員検索Modal(v)
        }}
        isShow={is社員検索Modal}
        setSyain={(社員) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T請求内訳 = 選択行.dataItem
            casted.内訳担当社員氏名 = 社員.社員氏名
            casted.内訳担当社員コード = 社員.社員コード
            casted.請求内訳担当社員ID = 社員.社員ID
            detailDataGrid?.refresh()
          }
        }}></SyainSearchModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          if (選択行 && 選択行.dataItem) {
            const casted: T請求内訳 = 選択行.dataItem
            casted.計上乗務員社員名 = 乗務員.社員氏名
            casted.計上乗務員社員コード = 乗務員.社員コード
            casted.計上乗務員ID = 乗務員.乗務員ID
            detailDataGrid?.refresh()
          }
        }}></ZyomuinSearchModal>
    </>
  )
}
export default MasterNinusiSeikyuRegister
